import React from 'react';
import { Box, Skeleton } from '@mui/material';


const TileSkeleton = () => (
  <Box sx={{ borderRadius: 2, border: '1px solid #f1f5f9', bgcolor: '#fff', p: '14px 16px', display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
    <Skeleton variant="rounded" width={38} height={38} sx={{ borderRadius: 2, flexShrink: 0 }} />
    <Box sx={{ flex: 1 }}>
      <Skeleton variant="text" width="50%" height={14} sx={{ mb: 0.5 }} />
      <Skeleton variant="text" width="40%" height={28} sx={{ mb: 0.3 }} />
      <Skeleton variant="text" width="65%" height={12} />
    </Box>
  </Box>
);

const ChartSkeleton = () => (
  <Box sx={{ bgcolor: '#fff', borderRadius: 2, border: '1px solid #e2e8f0', p: 2 }}>
    <Skeleton variant="text" width={140} height={16} sx={{ mb: 1.5 }} />
    <Skeleton variant="rounded" width="100%" height={120} sx={{ borderRadius: 1 }} />
  </Box>
);

const SKELETON_HEADER_COLS = [
  { id: 'sh-rank', w: 30 }, { id: 'sh-ticker', w: 52 }, { id: 'sh-total', w: 80 },
  { id: 'sh-accum', w: 72 }, { id: 'sh-break', w: 72 }, { id: 'sh-label', w: 68 },
  { id: 'sh-phase', w: 56 }, { id: 'sh-dist', w: 60 }, { id: 'sh-price', w: 80 },
  { id: 'sh-entry', w: 48 }, { id: 'sh-stop', w: 48 }, { id: 'sh-target', w: 48 },
  { id: 'sh-readiness', w: 42 }, { id: 'sh-more', w: 30 },
];
const SKELETON_ROW_IDS = ['sk-r1', 'sk-r2', 'sk-r3', 'sk-r4', 'sk-r5', 'sk-r6', 'sk-r7', 'sk-r8'];

const TableSkeleton = () => (
  <Box sx={{ borderRadius: 2, border: '1px solid #e2e8f0', bgcolor: '#fff', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.04)' }}>
    <Box sx={{ display: 'flex', gap: 1, px: 2, py: 1.2, bgcolor: '#fafbfc', borderBottom: '1px solid #e2e8f0' }}>
      {SKELETON_HEADER_COLS.map(({ id, w }) => (
        <Skeleton key={id} variant="text" width={w} height={14} sx={{ flexShrink: 0 }} />
      ))}
    </Box>
    {SKELETON_ROW_IDS.map((rowId) => (
      <Box key={rowId} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 1, borderBottom: '1px solid #f8fafc' }}>
        <Skeleton variant="text" width={20} height={16} sx={{ flexShrink: 0 }} />
        <Skeleton variant="text" width={52} height={18} sx={{ flexShrink: 0 }} />
        <Skeleton variant="rounded" width={80} height={8} sx={{ borderRadius: 1, flexShrink: 0 }} />
        <Skeleton variant="rounded" width={72} height={8} sx={{ borderRadius: 1, flexShrink: 0 }} />
        <Skeleton variant="rounded" width={72} height={8} sx={{ borderRadius: 1, flexShrink: 0 }} />
        <Skeleton variant="rounded" width={60} height={20} sx={{ borderRadius: 4, flexShrink: 0 }} />
        <Skeleton variant="text" width={40} height={16} sx={{ flexShrink: 0 }} />
        <Skeleton variant="rounded" width={56} height={20} sx={{ borderRadius: 4, flexShrink: 0 }} />
        <Skeleton variant="rounded" width={72} height={8} sx={{ borderRadius: 1, flexShrink: 0 }} />
        <Skeleton variant="text" width={44} height={16} sx={{ flexShrink: 0 }} />
        <Skeleton variant="text" width={44} height={16} sx={{ flexShrink: 0 }} />
        <Skeleton variant="text" width={44} height={16} sx={{ flexShrink: 0 }} />
        <Skeleton variant="text" width={40} height={16} sx={{ flexShrink: 0 }} />
        <Skeleton variant="circular" width={24} height={24} sx={{ flexShrink: 0, ml: 'auto' }} />
      </Box>
    ))}
  </Box>
);

const DialogSkeleton = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
    <Box sx={{ p: 2, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #e2e8f0' }}>
      <Skeleton variant="text" width={200} height={18} sx={{ mb: 1.5 }} />
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 2 }}>
        {[0, 1, 2].map(i => (
          <Box key={i}>
            <Skeleton variant="text" width="50%" height={12} />
            <Skeleton variant="text" width="70%" height={24} sx={{ mt: 0.5 }} />
          </Box>
        ))}
      </Box>
      <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
        {[0, 1, 2, 3, 4].map(i => (
          <Skeleton key={i} variant="rounded" width={100} height={26} sx={{ borderRadius: 1.5 }} />
        ))}
      </Box>
    </Box>
    <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1.5 }}>
      {[0, 1, 2, 3].map(i => (
        <Box key={i}>
          <Skeleton variant="text" width="40%" height={12} />
          <Skeleton variant="rounded" width="100%" height={10} sx={{ borderRadius: 1, mt: 0.5 }} />
        </Box>
      ))}
    </Box>
    <Skeleton variant="text" width={180} height={16} />
    <Skeleton variant="rounded" width="100%" height={200} sx={{ borderRadius: 1 }} />
  </Box>
);

// ═══════════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════════

// ═══════════════════════════════════════════════════════════════════════════

export { TileSkeleton, ChartSkeleton, TableSkeleton, DialogSkeleton };
